export * from './lib/resize-observer.module';
export * from './lib/resize-observer.directive';
export * from './lib/resize-observer.service';
